import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationPendingPage} from 'features/deposit/onboarding/pages/DepositApplicationPendingPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/pending',
)({
  component: DepositApplicationPendingPage,
  validateSearch: (search) => {
    return {
      pendingCode: search.pendingCode as string | undefined,
      productCode: search.productCode as string | undefined,
    };
  },
});
